// src/pages/CarouselPage.js
import React, { useState, useEffect } from "react";

const CarouselPage = () => {
  // Array of image sources
  const images = [
    "https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/creta-electric/highlights/creta-ev-des-banner.jpg",
    "https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/ioniq/ioniqnov2024-home-orignal-pc.jpg",
    "https://www.hyundai.com/content/dam/hyundai/in/en/images/hyundai-story/duo/home_orignal_cngduopc.jpg",
    "https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/Alcazar/Highlights/pc/venueadventurehomepc.jpg",
    "https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/Alcazar/Highlights/mob/alcazarhomepc1.jpg",
    "https://www.hyundai.com/content/dam/hyundai/in/en/data/find-a-car/Exter/Highlights/knightinnerkvpc.jpg",
    "https://cdn.bajajauto.com/-/media/images/chetak/chetak-3501/top-banners/3501-web-1920x800.webp",
    "https://cdn.bajajauto.com/-/media/bajaj-auto/freedom-product/assets/banner-web.webp",
    "https://cdn.bajajauto.com/-/media/assets/bajajauto/bikes/pulsar-ns400-2024/homepage-banners/ns400-homebanner-web.jpg",
    "https://cdn.bajajauto.com/-/media/assets/bajajauto/bikes/pulsar-k-2024/hero-banner/web-banner.webp",
    "https://media.triumphmotorcycles.co.uk/image/upload/f_auto/q_auto:eco/sitecoremedialibrary/media-library/images/motorcycles/in-scrambler%20400%20my24%20colour%20update/wyp__24_scrambler%20digital%20adapts_1920x1080-1.jpg",
    "https://media.triumphmotorcycles.co.uk/image/upload/f_auto/q_auto:eco/sitecoremedialibrary/media-library/images/motorcycles/modern-classics/my25/bajaj%20-%20india/speed%20t4/speedt4-bajaj-my25-hpr-1920x1080.jpg",
    "https://media.triumphmotorcycles.co.uk/image/upload/f_auto/q_auto:eco/sitecoremedialibrary/media-library/images/motorcycles/trident%20660%20-%202025/triumph-trident660_my25_1920.png",
    "https://media.triumphmotorcycles.co.uk/image/upload/f_auto/q_auto:eco/sitecoremedialibrary/media-library/images/motorcycles/modern-classics/my25/bajaj%20-%20india/speed%20400%20my25/triumph_my25_speed-400.jpg",
    "https://imgd.aeplcdn.com/1280x720/n/cw/ec/138933/scrambler-400-right-front-three-quarter.gif?isig=0",
  ];

  // State to track the current image index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to go to the next image
  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to go to the previous image
  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  // Auto-change images every 1 second (1000ms)
  useEffect(() => {
    const intervalId = setInterval(nextImage, 5000);

    // Clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='text-center w-full '>
      {/* Image Carousel */}
      <div className='relative w-full overflow-hidden'>
        {/* Carousel Image */}
        <div className='overflow-hidden md:p-0'>
          <img
            src={images[currentIndex]}
            alt={`Carousel Image ${currentIndex + 1}`}
            className='w-full h-[25vh] md:h-[40vh] lg:h-[55vh] xl:h-[65vh] transition-transform duration-700 ease-in-out transform rounded-xl'
            style={{
              transform: "scale(1)", // Zoom-in effect
              opacity: 1,
            }}
          />
        </div>

        {/* Carousel Controls */}
        <div className='absolute top-1/2 left-0 right-0 flex justify-between px-4'>
          <button
            onClick={prevImage}
            className='bg-white text-black p-1 md:p-3 rounded-full opacity-85 hover:opacity-100 transition'
          >
            &#60;
          </button>
          <button
            onClick={nextImage}
            className='bg-white text-black p-1 md:p-3 rounded-full opacity-85 hover:opacity-100 transition'
          >
            &#62;
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarouselPage;
